<template>
    <v-container class="fill-height">
        <v-layout row wrap>
            <v-flex xs12 sm6 offset-sm3 lg4 offset-lg4 xl2 offset-xl5>
                <v-card class="forgot-card">
                    <loading-indicator></loading-indicator>
                    <v-layout class="text-center mb-5">
                        <v-flex xs12>
                            <h1 class="pt-5">Forgot Password</h1>
                        </v-flex>
                    </v-layout>
                    <v-card-text>
                        <v-form>
                            <v-text-field v-if="this.success == null || empty " v-model="user.email" label="Email"></v-text-field>
                            <p v-if="this.success == null || empty ">Forgot your password? You can reset your account's password via Email.</p>
                            <v-btn v-if="this.success == null || empty" block depressed large @click="handleSendButton" color="accent">Send Email</v-btn>
                            <div v-if="(this.success !== null) && !empty" class="text-center success--text mt-3 mb-5 success-message">{{success}}</div>
                            <div v-if="(this.forgotPasswordError !== null) && !empty" class="text-center error--text mt-3 mb-5 error-message">{{forgotPasswordError}}</div>
                            <v-btn block text @click="goBack" class="mt-5">Back</v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import LoadingIndicator from '@/components/_layouts/LoadingIndicator'
    export default {
        components: {
            LoadingIndicator
        },
        mounted() {
            this.empty = true
        },
        data: () => ({
            user: {
                email: null,
            },
            show: false,
            empty: true,
        }),
        methods: {
            ...mapActions({
                sendForgotPassword: 'account/sendForgotPassword',
            }),
            handleSendButton(){
                this.empty = false;
                this.sendForgotPassword(this.user.email);
            },
            goBack () {
                this.$router.push('/')
            }
        },
        computed: {
            ...mapGetters({
                forgotPasswordError: 'account/forgotPasswordError',
                users: 'user/users',
                error: 'user/error',
                success: 'account/forgotPasswordSuccess',
            })
        }
    }
</script>

<style scoped>
    .forgot-card {
        margin-top: 100px;
        padding: 0 20px 20px 20px;
    }
    .error-message {
        height: 20px;
        font-weight: bold;
    }
    @media only screen and (max-width: 350px) {
        .forgot-card {
            margin-top: 70px;
        }
    }
</style>
